export enum DateFormat {
  YYYY_MM_DD = 'yyyy-mm-dd',
  MM_DD_YYYY = 'mm-dd-yyyy',
  DD_MM_YYYY = 'dd-mm-yyyy'
}

export enum TimeFormat {
  H24 = '24h',
  H12 = '12h'
}

export enum DisplayMode {
  COMBINED = 'combined',
  SEPARATE = 'separate'
}

export const DEFAULT_DATE_FORMAT = DateFormat.YYYY_MM_DD;
export const DEFAULT_TIME_FORMAT = TimeFormat.H24;
export const DEFAULT_DISPLAY_MODE = DisplayMode.COMBINED;
export const DEFAULT_TIME_STEP = 15;

export const DATE_FORMAT_OPTIONS = [
  { value: DateFormat.YYYY_MM_DD, label: 'YYYY-MM-DD' },
  { value: DateFormat.MM_DD_YYYY, label: 'MM-DD-YYYY' },
  { value: DateFormat.DD_MM_YYYY, label: 'DD-MM-YYYY' }
];

export const TIME_FORMAT_OPTIONS = [
  { value: TimeFormat.H24, label: '24 Hour (HH:MM)' },
  { value: TimeFormat.H12, label: '12 Hour (HH:MM AM/PM)' }
];

export const DISPLAY_MODE_OPTIONS = [
  { value: DisplayMode.SEPARATE, label: 'Separate Fields' },
  { value: DisplayMode.COMBINED, label: 'Combined Field' }
];

export const TIME_STEP_OPTIONS = [
  { value: 5, label: '5 minutes' },
  { value: 10, label: '10 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 60, label: '1 hour' }
];

export const DATE_FORMAT_PATTERNS = {
  [DateFormat.YYYY_MM_DD]: /^\d{4}-\d{2}-\d{2}$/,
  [DateFormat.MM_DD_YYYY]: /^\d{2}-\d{2}-\d{4}$/,
  [DateFormat.DD_MM_YYYY]: /^\d{2}-\d{2}-\d{4}$/
};

export const TIME_FORMAT_PATTERNS = {
  [TimeFormat.H24]: /^\d{1,2}:\d{2}$/,
  [TimeFormat.H12]: /^\d{1,2}:\d{2}\s?(AM|PM)$/i
};

export interface DateTimeValue {
  date: string;
  time: string;
}

export interface DateTimeRangeValue {
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
}

export interface ValidationError {
  field: string;
  message: string;
}

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
}

export interface DateTimeConfig {
  dateFormat: DateFormat;
  timeFormat: TimeFormat;
}

export const DEFAULT_DATE_TIME_CONFIG: DateTimeConfig = {
  dateFormat: DEFAULT_DATE_FORMAT,
  timeFormat: DEFAULT_TIME_FORMAT
};
